import { useState } from 'react';
import axios from 'axios';
import './ContactForm.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const ContactForm = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');

    try {
      await axios.post(`${API}/contact`, formData);
      setStatus('success');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      setStatus('error');
      console.error('Contact error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact-form-section" data-testid="contact-form-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <h2 className="section-title">Get In Touch</h2>
          <div className="gradient-line mx-auto"></div>
          <p className="section-subtitle">Have a question? Send us a message and we'll get back to you soon.</p>
        </div>

        {status === 'success' && (
          <div className="alert-success" data-testid="contact-success">
            ✓ Thank you for your message! We'll be in touch soon.
          </div>
        )}
        
        {status === 'error' && (
          <div className="alert-error" data-testid="contact-error">
            ✗ Something went wrong. Please try again or contact us directly.
          </div>
        )}

        <form onSubmit={handleSubmit} className="contact-form" data-testid="contact-form">
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Name *</label>
              <input
                type="text"
                required
                className="form-input"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                data-testid="contact-name"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Email *</label>
              <input
                type="email"
                required
                className="form-input"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                data-testid="contact-email"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Phone</label>
              <input
                type="tel"
                className="form-input"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                data-testid="contact-phone"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Subject</label>
              <input
                type="text"
                className="form-input"
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                data-testid="contact-subject"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Message *</label>
            <textarea
              required
              className="form-input"
              rows="5"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              placeholder="Tell us about your business or question..."
              data-testid="contact-message"
            ></textarea>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="submit-button"
            data-testid="contact-submit"
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
